import { DataGrid } from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

export const ReservationBundleDialog = ({
  open,
  onClose,
  rowData, // This can be single object or array
  columns,
  title = "Reservation Details",
  rowHeight=80,
  onRowClick

}) => {
  
  const reservations = rowData?.reservations || [];
  console.log("rowdata", reservations)
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        {title}
        <br />
        {rowData?.reservations?.[0]?.firstName && rowData?.reservations?.[0]?.lastName ? 
          `For Student: ${rowData.reservations[0].firstName} ${rowData.reservations[0].lastName} (Student ID: ${rowData.reservations[0].studentId})` : ''}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div style={{ height: 580, width: "100%" }}>
          <DataGrid
            rows={reservations}
            columns={columns}
            getRowId={(reservations) => reservations.reservationId}
            disableSelectionOnClick
            rowHeight={rowHeight}
            onRowClick={onRowClick}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ReservationBundleDialog;